<script>
import Layout from '@layouts/loginLayout.vue'
import MottoIcon from '@components/motto-icon.vue'

export default {
  page: {
    title: 'User Agreement',
    meta: [
      {
        name: 'description',
        content: 'The User Agreement page.',
      },
    ],
  },
  components: {
    Layout,
    MottoIcon,
  },
}
</script>

<template>
  <Layout>
    <MottoIcon
      :class="$style.backButtonTop"
      name="Arrow"
      icon-color="gray"
      class="cursor-pointer"
      @click.native="$router.go(-1)" />
    <div :class="$style.userAgreement">
      <h1 class="sr-only">User Agreement</h1>
      <h4>MOTTO PORTAL USER AGREEMENT</h4>
      <p>
        This Motto Portal User Agreement (“Agreement”) is between you, (“Member”), and Motto Franchising, LLC (“Motto”),
        a Delaware Limited Liability Company whose address is 5075 S. Syracuse Street, Denver, CO 80237. To be permitted
        access to the Motto Portal and the linked resources (“Portal,” as defined in paragraph 1), you must be a Member
        as defined in Section 2 of this Agreement and complete Motto’s on-line registration process. After reading this
        Agreement, if you agree to all of its terms and conditions, without modification, click on “I ACCEPT”. If you do
        not agree to all of the terms and conditions of this Agreement, you cannot be a Member and will not be permitted
        access to the Portal. This Agreement shall have no force or effect until it is accepted in the State of Colorado
        by Motto, and Member is notified on-line of such acceptance. Your continued use of the Portal is deemed
        acceptance of this Agreement and Member agrees that this Agreement supersedes and replaces all prior Agreements.
        Member agrees that if there are any conflicts between the terms and conditions of this Agreement and any prior
        versions, the terms and conditions of this Agreement shall control.
      </p>
      <br />
      <ol>
        <li id="uag-1">
          <strong>Motto Portal.</strong>
          The Portal is an extranet website service comprised of (a) computing services; (b) information and other
          content provided by Motto and Members; (c) access to the services and information; (d) direct access to email
          services; (e) Motto Design Center; (f) a data entry and upload feature; (g) products for sale; and (h) a
          billing feature. Motto may, from time to time, in its sole discretion and without notice, change or
          discontinue the Portal or add to, revise, or delete any or all aspects of the Portal. At any time and without
          notice, Motto in its sole discretion may elect, but is not obligated, to introduce or grant different grades
          of service, introduce or grant different degrees of access to information and/or analysis, or introduce new
          features and future versions of the Portal which may change functions, introduce new or revised security
          restrictions, or limit access to information and/or analysis. Motto may limit, create different priorities for
          different Members or update and/or cancel some or all of the functions of the Portal at any time and without
          notice. Motto may or may not make any such services, features or changes available to Member, and Motto shall
          incur no liability in connection with any such introduction, grant or change in services or features. Member
          agrees to bear all risks and hold Motto harmless for any and all effects that any of the above changes may
          have on Member’s ability to use the Portal for any purpose. By continuing to use the Portal after notice of
          any change is posted on the Portal, Member signifies its consent to all such changes, including but not
          limited to all changes to this Agreement. Member is responsible for all equipment, telephone connectivity and
          other services necessary to access the Portal. Motto further reserves the right, in its sole discretion, to
          modify, supplement, delete, discontinue or remove any file, publication, information, communication or other
          content appearing on, uploaded to or transmitted through the Portal. Motto provides the Portal for the purpose
          of sharing positive information and ideas, inspiring creativity, fostering the Motto Affiliate network, and
          streamlining access to the Motto membership resources (the “Purpose”).
        </li>
        <li id="uag-2">
          <strong>Member.</strong>
          To be a Member you must be one of the following: (a) a Motto Franchisee or employee of a Moto Franchisee who
          is current on all annual dues and fees owed to Motto and in compliance with all applicable Motto policies
          (including, but not limited to, the Motto Brand Identity Trademark and Graphic Standards manual); (b) a
          current employee, officer, director or owner of Motto, any Motto corporate affiliate; or (c) a Motto Approved
          Supplier who is in full compliance with all of the terms and conditions of its Approved Supplier Agreement as
          determined solely by Motto. Motto is not responsible for any costs or expenses that you incur as a result of
          losing access to the Portal because you cease to be eligible to be a Member, as defined in this paragraph.
        </li>
        <li id="uag-3">
          <strong>Motto Approved Suppliers.</strong>
          Motto Approved Suppliers. Motto from time to time enters into contractual arrangements with suppliers of
          certain products and services (the “Approved Suppliers”) that are deemed to be useful to Members and others.
          Motto or Motto Approved Suppliers may provide Members with information about these products and services,
          including special offers and product or service updates. Motto may, in its sole discretion, (a) post
          information about and provide Members access to Approved Suppliers on the Portal, (b) communicate with Member
          directly about such Approved Suppliers, and/or (c) provide Member’s mottomortgage.com to such Approved
          Suppliers so that they may communicate with Member directly.
        </li>
        <li id="uag-4">
          <strong>License.</strong>
          Motto grants to Member a non-exclusive, non-assignable, limited license to use the Portal strictly in
          accordance with all the terms of this Agreement, which license Motto may terminate at any time without notice
          to Member if Motto believes a violation of this Agreement has occurred or the Member ceases to be eligible to
          be a Member, as defined in paragraph 2. Only one individual may use the account established by the Member (the
          “Account”) at one time, and a single Account may only be used for the benefit of the Member who registered for
          that Account.
        </li>
        <li id="uag-5">
          <strong>Disclaimer of Warranties and Limitation of License.</strong>
          Motto MAKES NO WARRANTIES OR GUARANTIES AS TO THE AVAILABILITY OR RELIABILITY OF THE PORTAL OR THE INFORMATION
          MEMBERS PLACE ON THE PORTAL. Motto MAKES NO REPRESENTATIONS ABOUT THE SUITABILITY OF THE INFORMATION,
          SOFTWARE, PRODUCTS, AND SERVICES CONTAINED ON THE PORTAL FOR ANY PURPOSE. ALL SUCH INFORMATION, SOFTWARE,
          PRODUCTS, AND SERVICES ARE PROVIDED “AS IS, AS AVAILABLE” WITHOUT WARRANTY OF ANY KIND. Motto HEREBY DISCLAIMS
          ALL WARRANTIES AND CONDITIONS WITH REGARD TO ALL INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES REGARDING THE
          PORTAL, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
          TITLE, AND NONINFRINGEMENT. IN NO EVENT SHALL Motto OR ITS EMPLOYEES, AFFILIATES, PARENT COMPANIES,
          DIRECTORS/MANAGERS, SHAREHOLDERS/MEMBERS, OFFICERS OR AGENTS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE,
          INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF, OR IN ANY WAY CONNECTED WITH, THE USE OF THE
          PORTAL OR ANY INFORMATION THEREON, OR WITH THE DELAY OR INABILITY TO USE THE PORTAL, OR FOR ANY INFORMATION,
          SOFTWARE, PRODUCTS, AND SERVICES THROUGH THE PORTAL, OR OTHERWISE ARISING OUT OF THE USE OF THE PORTAL,
          WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE, (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR
          LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION, LOSS OF ANALYSIS, OR OTHER LOSS) ARISING
          OUT OF THE USE OF OR INABILITY TO USE THE PORTAL OR THE FAILURE TO PROVIDE SUPPORT FOR OR RESOLVE ANY SUPPORT
          ISSUES REGARDING THE PORTAL, EVEN IF Motto HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. IN ANY CASE,
          Motto’S ENTIRE LIABILITY UNDER ANY PROVISION OF THIS AGREEMENT SHALL BE LIMITED TO THE AGGREGATE AMOUNT YOU
          HAVE PAID, OR WHICH HAS BEEN PAID ON YOUR BEHALF, DIRECTLY TO Motto FOR ACCESS TO THE PORTAL.
        </li>
        <li id="uag-6">
          <strong>Member Access.</strong>
          Motto reserves the right to suspend or terminate Member’s access to the Portal and to terminate this Agreement
          without notice to Member, at any time, in the event: (a) Member ceases or fails, for any reason, to meet the
          definition of a Member, as determined solely by Motto; (b) Member fails to honor or is in breach of any term
          or condition of this Agreement, as determined solely by Motto; (c) Member ceases, for any reason, to be
          affiliated with the Motto organization; (d) Member fails to notify Motto of a change of office address; (e)
          Member engages in any Prohibited Use of Portal (see Section 11 hereof) or any other conduct which, in the sole
          judgment of Motto, compromises or may compromise the value, integrity or viability of the Portal or detracts
          from the reliability or reputation of such extranet service or of the Motto name or organization.
        </li>
        <li id="uag-7">
          <strong>Member Access Fees.</strong>
          There is currently no Member Access Fee for the Portal. Motto may, in its sole discretion, impose an Access
          Fee for Members at any time by posting notice on the Portal of any such Access Fee, the amount of such Access
          Fee, and the date such Access Fee becomes effective, along with instructions for payment. Although there is
          not a Member Access Fee for the Portal, the Member Franchisee must be current on their fees or the service may
          be suspended until such time that the fees are paid in full (see Section 2).
        </li>
        <li id="uag-8">
          <strong>Modification of Agreement.</strong>
          This Agreement may be modified by Motto at any time, without limitation, by posting notice on the Portal of
          any modifications to the terms or conditions of this Agreement. Unless otherwise specified in the notice, any
          modifications to the Agreement shall be effective when posted on the Portal.
        </li>
        <li id="uag-9">
          <strong>Member&rsquo;s Use of Portal.</strong>
          Member agrees that any and all information Member places on the Portal shall at all times be:
          <ol class="uag-sublist" type="a">
            <li id="uag-9a">True and accurate in all respects to Member’s knowledge and belief;</li>
            <li id="uag-9b">Corrected promptly by Member;</li>
            <li id="uag-9c">Lawfully placed on the Portal; and</li>
            <li id="uag-9d">
              Accessed, used, and distributed strictly in accordance with all terms of this Agreement.
            </li>
          </ol>
        </li>
        <li id="uag-10">
          <strong>Limited Access to and use of Motto Advertising Materials.</strong>
          In limited circumstances Motto may make available for download via the Portal certain audio and visual
          advertising materials, including but not limited to radio commercials, jingles and other proprietary music,
          television commercials, or ad slicks (the “Motto Advertising Materials”). You hereby acknowledge and agree
          that you will observe any limits on the use of such Motto Advertising Materials that are required by Motto, by
          law, or by anyone with an interest in such Motto Advertising Materials. The use of any Motto Advertising
          Materials may be discontinued at any time at Motto’s sole option, and you agree to take any action required to
          discontinue such use when required. You further agree to (a) use the Motto Advertising Materials in the form
          in which they have been created, without modifications other than those permitted by the system or the Motto
          Brand Identity Trademark And Graphic Standards manual; (b) use the Motto Advertising Materials only for
          promoting and advertising your Motto mortgage brokerage activities and not in any way that harms, disparages,
          detracts from, or devalues Motto; (c) comply with any expiration date(s) for such Motto Advertising Materials,
          whether such dates are posted on slates preceding televisions commercials, posted on the Portal, or
          communicated in any other manner; (d) upon an expiration date that applies to particular Motto Advertising
          Materials, immediately delete, destroy, and otherwise stop any and all usage of, any products or materials,
          even ones that you have created or purchased, that incorporate or use any portion of such expired Motto
          Advertising Materials; (e) upon any notification from Motto requiring that you do so, which may consist solely
          of posting the notification on the Portal, immediately delete, destroy, and otherwise stop any and all usage
          of, any products or materials, even ones that you have created or purchased, that incorporate or use any
          portion of the Motto Advertising Material that is the subject of such notification; and (f) regularly check
          the Portal and any other communication from Motto for such notifications and expirations. You also hereby
          agree that if you modify the Motto Advertising Materials in any manner, including but not limited to adding on
          your business contact information, you do so at your own risk and you assume any and all liability for (i) any
          claims that such usage is improper, including copyright infringement or a misleading or false advertisement
          and (ii) any and all costs incurred by Motto arising from any claims relating to your usage of the Motto
          Advertising Materials, including court costs and attorney fees.
        </li>
        <li id="uag-11">
          <strong>Prohibited Use of Portal.</strong>
          Member agrees to abide by all applicable local, state, national, and foreign laws, treaties, and rules and
          regulations in connection with the Portal and agrees not to use the Portal or any feature, aspect, or data in,
          a part of, or from the Portal to:
          <ol class="uag-sublist" type="a">
            <li id="uag-11a">
              Post or send any unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain
              letters, pyramid schemes, or any other form of duplicative or unsolicited messages, whether commercial or
              otherwise; harvest, collect, gather, or assemble information or data regarding other Members, including,
              but not limited to, e-mail addresses and payment information without their consent;
            </li>
            <li id="uag-11b">
              Transmit, upload, post or publish on the Portal any unlawful, harassing, libelous, abusive, tortious,
              defamatory, threatening, harmful, invasive to another’s privacy, vulgar, obscene, sexually oriented,
              pornographic, or otherwise objectionable material of any kind or nature;
            </li>
            <li id="uag-11c">
              Transmit any material that Member knows or should know contains a software virus or viruses, or other
              harmful or objectionable computer code, files, program or routine such as Trojan horses, worms, time
              bombs, cancel bots, or popups;
            </li>
            <li id="uag-11d">
              Attempt to gain unauthorized access to the Website, other accounts, computer systems, networks, or Members
              connected to or using the Website, through password mining or any other means;
            </li>
            <li id="uag-11e">
              Interfere with or disrupt servers, networks, hardware, software, or Members connected to or using the
              Portal, or violate the licenses, policies, procedures, or regulations of such;
            </li>
            <li id="uag-11f">
              Attempt to gain unauthorized access to the Portal, other accounts, computer systems, networks, or Members
              connected to or using the Portal, through password mining or any other means;
            </li>
            <li id="uag-11g">
              Harass or interfere with another Member’s use or enjoyment of the Portal or other Member’s information or
              data on the Portal;
            </li>
            <li id="uag-11h">
              Engage in “scamming”, “spoofing”, “spamming” or any other objectionable or illegal e-mail activities,
              whether or not using the e-mail alias address assigned by Motto to Member;
            </li>
            <li id="uag-11i">
              Transmit, upload, post or publish any material which may infringe upon any intellectual property or other
              rights of any person including without limitation trademark rights, copyrights, or rights of publication
              in any form or format without the express written authorization of the owner of the copyrighted or
              proprietary material. When copyrighted or proprietary material is uploaded, posted or otherwise published
              by Member on the Portal, Member agrees to include with such material all notices of copyright or claims of
              proprietary rights that are required by law;
            </li>
            <li id="uag-11j">
              Copy any portion of the Portal for any purpose, including, but not limited to, copy any portion of the
              Portal for transmission or use, directly or indirectly, on any computerized electronic exchange other than
              the Portal, excepting only that portion of the information or data on the Portal that Member uploaded to
              the Portal through Member’s Account;
            </li>
            <li id="uag-11k">Grant access to Member’s Account to any other person;</li>
            <li id="uag-11l">
              Transfer, rent, lease, grant a security interest in, or otherwise encumber in any way any portion of the
              Portal or any of Member’s rights to access or use of the Portal, whether through this Agreement or
              otherwise;
            </li>
            <li id="uag-11m">
              Delete any author attributions, legal notices, or proprietary designations or labels in any file that is
              uploaded;
            </li>
            <li id="uag-11n">
              Falsify the origin or source of software or other material contained in a file that is uploaded;
            </li>
            <li id="uag-11o">
              Transmit information that the Member knows or should know is unlawful without the express written
              authorization of the Cardholder as defined by the PCI DSS; or
            </li>
            <li id="uag-11p">
              Download any file posted by another Member that Member knows, or reasonably should know, cannot be legally
              distributed in such manner;
            </li>
            <li>
              Motto reserves the right to refrain from processing and/or to delete from the Portal any software, file,
              information, communication or other material or content that, in the judgment and sole discretion of
              Motto, is inconsistent with or contrary to the Purpose of the Portal or the prohibitions specified in this
              Section 11.
            </li>
          </ol>
        </li>
        <li id="uag-12">
          <strong>Member Responsibilities.</strong>
          <ol id="uag-sublist" type="a">
            <li id="uag-12a">
              Member agrees no other individual or entity, including other Members, shall access the Portal through
              Member’s Account. Member agrees it shall be responsible for any and all charges, claims, liabilities,
              losses, damages, costs and expenses (including reasonable attorney fees) that arise from any unauthorized
              access to the Portal through Member’s Account. Member agrees to comply with all applicable laws with
              respect to use of the Portal and with all rules and regulations adopted by Motto governing use of the
              Portal. Member is responsible for reading and complying with all rules, regulations, warnings, notices and
              instructions posted by Motto on the Portal.
            </li>
            <li id="uag-12b">
              Member is responsible for any and all information and data that Member directly or indirectly places on
              the Portal. Member shall indemnify and hold Motto and its shareholders, affiliates, parent companies,
              directors, officers, employees, and agents harmless from and against any and all claims that any
              information or data that Member places directly or indirectly on the Portal is inaccurate, incomplete or
              unauthorized in any respect.
            </li>
            <li id="uag-12c">
              Member acknowledges and agrees that all information Member places on the Portal is accessible by Motto at
              all times and may be revised by Motto to conform to any Portal requirement, although Motto is under no
              obligation to reformat any data and shall not be liable to Member or any other person for any information
              or data or revisions thereto.
            </li>
            <li id="uag-12d">
              Member hereby authorizes Motto to place cookies and other files on Member’s computer hard drive or other
              storage medium to assist the Portal in limiting access to only authorized Members and recording
              authentication information for the duration, activities, and content of each session of the Member on the
              Portal.
            </li>
            <li id="uag-12e">
              Member is responsible for any and all activities that occur under its Account, and must log off and exit
              from its Account at the end of each session of use. Member shall send Motto notice immediately upon being
              aware or suspicious of any unauthorized use of the Portal by any person.
            </li>
            <li id="uag-12f">
              Member grants Motto full access to any information regarding Member, Member’s Account, any information
              Member places on the Portal, all cookies and any other information gathered in connection with use of the
              Portal. Member hereby consents to the use and disclosure of any and all such information and data,
              including as may be required by law or by governmental authority, or as Motto may from time to time deem
              appropriate in accordance with Member’s affiliation with the Motto franchise network. This access
              specifically excludes Member’s Cardholder data as defined by the PCI DSS, which is transmitted to the
              authorized payment gateway and third party transaction processing system directly without being accessed
              or stored by Motto.
            </li>
            <li id="uag-12g">
              Member hereby grants Motto and its assigns a non-exclusive, unrestricted, perpetual royalty-free license
              to display, publish, and otherwise use any and all information or data Member places on the Portal.
            </li>
            <li id="uag-12h">
              Member acknowledges and agrees that if Motto reasonably suspects that any material information supplied by
              Member is untrue, inaccurate, unauthorized, not current, or incomplete, Motto in its sole and absolute
              discretion has the right to suspend or terminate Member’s access to the Portal, and may restore Member’s
              access to the Portal after any and all defaults have been cured to Motto’s satisfaction.
            </li>
            <li id="uag-12i">
              Member authorizes Motto to send Member e-mail messages and electronic communications, including but not
              limited to periodic company news updates, billing information, information concerning educational courses,
              special announcements, industry news of special interest and regional information. Member further
              authorizes Motto and Third Parties to send commercial electronic mail messages (as defined by the CAN-SPAM
              Act of 2003, and acts amendatory thereto) to Member at Member’s mottomortgage.com e-mail address. Member
              acknowledges and agrees that Motto may provide Member’s mottomortgage.com address to Third Parties who may
              send Member commercial electronic mail messages directly.
            </li>
            <li id="uag-12j">
              Except for Motto Approved Suppliers who will not be assigned a mottomortgage.com e-mail address, Member
              authorizes Motto to use the mottomortgage.com e-mail address assigned to Member by Motto as Member’s
              primary e-mail address in Member’s profile in the Portal.
            </li>
            <li id="uag-12k">
              Motto will provide email addresses only in a format in accordance with Motto’s email policies. Motto is
              not responsible for any costs or expenses, including, but not limited to, those for printing promotional
              materials with non-compliant email addresses, that Member incurs as a result of requesting a
              mottomortgage.com e-mail address that Motto determines, in its sole discretion, does not comply with such
              policies.
            </li>
            <li id="uag-12l">
              Member acknowledges and agrees that the E-mail Feature on the Portal is not warranted or represented to be
              private, reliable, timely, deliverable or available on a 24 hours per day/7 days per week basis.
            </li>
            <li id="uag-12m">
              Member acknowledges the Portal will not be available or accessible during routine scheduled downtime for
              maintenance.
            </li>
            <li id="uag-12n">
              Member acknowledges and agrees that spam and virus filters on the Portal may not catch e-mails directed to
              Member that contain spam or a virus.
            </li>
            <!--
            <li id="uag-12o">
                Member acknowledges that RE/MAX, in its sole discretion, may limit the size of file attachments to e-mails sent by a Member to another Member’s remax.net e-mail address.
            </li>
            <li id="uag-12p">
                Member acknowledges and agrees that if Member fails to update its e-mail accepting address, the E-mail Forwarding Feature of the Portal will not function and Member’s remax.net account may be cancelled.
            </li>
            <li id="uag-12q">
                Member hereby certifies that Member is the authorized user of the e-mail accepting address that Member has provided RE/MAX for use as the E-mail Forwarding Feature’s e-mail accepting address for Member.
            </li>
            <li id="uag-12r">
                Member agrees to promptly notify RE/MAX of any change in its e-mail accepting address linked to the E-mail Forwarding Feature. Member acknowledges that any failure to do so may adversely impact RE/MAX, including but not limited to under the provisions of the CAN-SPAM Act of 2003 and the Canadian Anti-SPAM Legislation. Therefore, Member agrees to accept and to indemnify and defend RE/MAX from any and all liability that may arise from Member’s failure to keep RE/MAX accurately informed and updated regarding Member’s current e-mail accepting address or Member’s authorized user status concerning such e-mail accepting address.
            </li>
            -->
            <li id="uag-12s">
              Member acknowledges and agrees that if Member is suspended or terminated by Motto, Member will not be able
              to access the Portal or Member’s e-mail.
            </li>
            <li id="uag-12t">
              If Member is a Motto Approved Supplier, Member agrees to comply with Motto’s advertising policies with
              respect to e-mail directed to Members.
            </li>
            <li id="uag-12u">
              Members who are Motto Approved Suppliers agree to respond on-line to all inquiries directed to them from
              Members about the Approved Supplier’s products and/or services by no later than the next business day
              after receipt of the inquiry.
            </li>
            <li id="uag-12v">
              Member acknowledges that all information Member places on the Portal (other than Member entered
              statistical and Cardholder payment data) is public, and not private, communication. Further, Member
              acknowledges that all information, pictures, analysis, postings, conferences, and other communications by
              other Members are not endorsed by Motto and such communications shall not be considered reviewed,
              screened, or approved by Motto. Motto reserves the right for any reason to remove, without notice, any
              information received from any Member. Motto reserves the right to deny, in its sole discretion, any Member
              access to this Portal or any portion thereof without notice.
            </li>
          </ol>
        </li>
        <li id="uag-13">
          <strong>No Unlawful or Prohibited Use.</strong>
          sAs a condition of Member’s use of the Portal, Member warrants that Member will not use the Portal for any
          purpose that is unlawful or prohibited by this Agreement.
        </li>
        <li id="uag-14">
          <strong>Support.</strong>
          Motto shall only provide on-line technical support for difficulties Member may have accessing the Portal or
          any of its features. Technical support shall not include any aspect of Member’s computer hardware, software,
          configurations, means of gaining access to the Internet, ability to browse the Internet, or ability to access
          any facet or portion of the Portal.
        </li>
        <li id="uag-15">
          <strong>Copyrights and Licenses.</strong>
          <ol class="uag-sublist" type="a">
            <li id="uag-15a">
              Motto hereby claims and reserves all rights in copyrights and other rights in and to the Portal, including
              the Portal name, front page, Portal graphics and all material and content originating with or provided by
              Motto, including any audio or visual advertising materials or other documents accessible through the
              Portal.
            </li>
            <li id="uag-15b">
              Except to the extent, if any, permitted by the “fair use” doctrine of copyright law, or as permitted in
              Section 10 above, Member agrees that wherever a copyright notice or claim is included (i) with or on any
              content or material or (ii) on any screen display on the Portal, that Member will not download, duplicate,
              forward, distribute, display, perform or otherwise use such content, material or screen display without
              the express written authorization from the owner of such copyright.
            </li>
            <li id="uag-15c">
              Member acknowledges and agrees that only the owner of copyrighted or proprietary material, and those
              authorized in writing by the owner of such material to do so, may upload copyrighted or proprietary
              material to the Portal. Member agrees that it will not upload copyrighted material to the Portal for the
              purpose of making such copyrighted material available to other Members without the express written
              authorization to do so from the owner of such copyright. For copyrighted material that Member is
              authorized to upload to the Portal, Member agrees it shall designate the copyrighted nature of such
              material and the scope of its permitted use. Member acknowledges and agrees that in posting or uploading
              any copyrighted material, changes to or deletion of author attribution or copyright notice is expressly
              prohibited.
            </li>
            <li id="uag-15d">
              Member agrees software or tools downloaded or otherwise available through access to the Portal may not be
              reverse engineered or otherwise tampered with unless specifically authorized in writing by the owner of
              the rights in such software or tools.
            </li>
            <li id="uag-15e">
              Member may upload public domain material to the Portal and may download such material for Member’s own
              use. Member is responsible for and assumes all risks regarding the determination of whether material
              downloaded from or posted on the Portal is in the public domain.
            </li>
          </ol>
        </li>
        <li id="uag-16">
          <strong>Disclaimer of Warranties and Exclusion of Liability.</strong>
          <ol class="uag-sublist" type="a">
            <li id="uag-16a">
              Motto does not endorse or guarantee the accuracy, completeness, truthfulness or reliability of any
              service, opinion, advice, communication, information or other material or content included on or made
              available on, over or through the Portal. Member hereby waives all claims against Motto, including any
              claims that arise as a result of Member’s use of or reliance upon the accuracy, completeness,
              truthfulness, security or reliability of any service, opinion, advice, communication, information or other
              material or content included on or made available on, over or through the Portal. Member expressly
              acknowledges that the provisions of this Section 16 relating to disclaimer of warranties and exclusion of
              liability shall also apply to any claims relating to access to services, information and other content
              provided by parties other than Motto, and any other content available through the Portal. Member agrees it
              will not hold Motto responsible for any selection or retention of, or the acts or omissions of, third
              parties in connection with the Portal.
            </li>
            <li id="uag-16b">
              Member expressly acknowledges that the Disclaimer of Warranties and Limitation of License set forth in
              Section 5 of this Agreement and Motto’s disclaimer of warranties and exclusion of liability set forth in
              this Section 16 shall also apply to any claims relating to access to services, information and other
              content provided by Members or parties other than Motto, and any other content available through the
              Portal. Member agrees it will not hold Motto responsible for any selection or retention of, or the acts or
              omissions of, third parties in connection with the Portal.
            </li>
          </ol>
        </li>
        <li id="uag-17">
          <strong>Indemnity.</strong>
          Member agrees to indemnify, defend, and hold harmless Motto and its shareholders/members, affiliates, parent
          companies, directors/managers, officers, employees, and agents from and against any and all claims, suits,
          proceedings, liabilities, losses, damages, costs and expenses whatsoever, including reasonable outside
          attorney fees and disbursements, court costs or arbitration costs, arising out of any breach or violation by
          Member of any term or condition of this Agreement. The obligations of Member to indemnify Motto shall survive
          expiration or termination of this Agreement.
        </li>
        <li id="uag-18">
          <strong>Privacy Provisions.</strong>
          As a Member, when you voluntarily complete Motto’s on-line registration process or provide information through
          any of the methods described in paragraph 1 above, we collect that information as well as data related to your
          Portal visit and usage. We collect personally identifiable information (including, but not limited to, name,
          address, email address and phone number) as well as cardholder data that is voluntarily provided to us by you.
          For example, you voluntarily provide personally identifiable information when you send us an email, use
          certain features of the Portal such as registering for or logging into the Portal, or enter Cardholder data
          for payment purposes. We collect detailed, transaction level data for each Member. In addition, during your
          visit we automatically collect certain aggregate information related to your Portal visit. Aggregate
          information is non-personally identifiable or anonymous information about you, including the date and time of
          your visit, your IP address, your computer browser information, the Internet address that you visited prior to
          and after reaching the Portal, the name of the domain and host you used to access the Internet, and the
          features of our Portal which you accessed.
        </li>
        <li id="uag-19">
          <strong>COOKIES, WEB BEACONS AND OTHER TRACKING TECHNOLOGIES.</strong>
          Our Portal uses cookies, which are small, commonly-used files that are transferred to your computer by us or a
          third party when you allow your browser to accept cookies. Similarly, Motto and Third Parties may also use
          “web beacons,” “pixel tags” or other tracking technologies, which are typically small pieces of code placed on
          a web page to monitor behavior and collect certain data regarding the actions of our Members online. These
          cookies and other technologies may be used to track your online traffic patterns, to enhance your experience
          when using the Portal, to store information during your session, to personalize your experience on the Portal
          based on your preferences and selections, to target advertising or content to you (as described further below)
          and to collect information about you and your visit to our Portal for other marketing and business purposes.
          Our Portal may use cookies or other technologies provided by website analytics services such as Google
          Analytics to help us better understand how the Portal is used. By tracking how and when you use the Portal,
          these technologies help us determine which features and content on the Portal are most important to our
          Members.
          <br />
          <br />
          Data about your activities online may be collected for use in providing advertising tailored to your
          individual interests, either by us, our affiliates, or Third Parties. We may use Third Parties such as network
          advertisers and ad exchanges to serve advertisements across the Internet and may use third party analytics
          service providers to evaluate and provide us and/or third parties with information about the use of these ads
          on third party websites and viewing of ads and of our content. The information collected may include
          information about your visits to the Portal, such as the pages you have viewed. These third-party tracking
          technologies may be set to, among other things: (a) help deliver advertisements to you that you might be
          interested in; (b) prevent you from seeing the same advertisements too many times; and (c) understand the
          effectiveness of the advertisements that have been delivered to you. This collection and ad targeting takes
          place both on the Portal and on third-party websites or services that participate in the ad network, such as
          websites that feature advertisements delivered by the ad network. This process also helps us track the
          effectiveness of our marketing efforts. We and third-party vendors, including Google, use first-party cookies
          (such as the Google Analytics cookie) and third-party cookies (such as a DoubleClick cookie) together to
          report how your ad impressions, other uses of ad services, and interactions with these ad impressions and ad
          services are related to visits to the Portal.
          <br />
          <br />
          Please note, our Services do not currently respond to browser do-not-track signals. Further, our third party
          advertising networks may install their own cookies, including cookies that may track our visitors to the
          Portal over time and across third party sites, and which may change over time without notice to you or Motto.
        </li>
        <li id="uag-20">
          <strong>How Motto Uses Information.</strong>
          Motto uses collected information to grant Members access to all of the services and information encompassed by
          the Portal (including but not limited to the email feature and the other services and functions set forth in
          Paragraph 1 above). We also use such information to: respond to inquiries or service requests and monitor such
          responses; provide information about and market our products or services or those of the Motto franchise
          network of independently owned offices and Third Parties; resolve problems; and manage the Portal and assess
          its usage. In addition, collected cardholder data may be transferred to third party service providers, such as
          Chase Paymentech, Inc. and Cybersource, Inc. Such third party providers will be responsible for collecting,
          verifying, processing, and storing cardholder data.
        </li>
        <li id="uag-21">
          <strong>Governing Law.</strong>
          This Agreement shall be governed by the laws of the state of Colorado without regard to its conflict of laws
          principles. The courts of Colorado shall have exclusive jurisdiction over all disputes relating to this
          Agreement. Member agrees that venue and jurisdiction for judicial proceedings is proper and shall exist
          exclusively in Denver, Colorado.
        </li>
        <li id="uag-22">
          <strong>Entire Agreement.</strong>
          Unless modified as provided in Section 8, this Agreement includes the entire understanding between Motto and
          Member regarding the subject hereof and supersedes all previous agreements between them.
        </li>
        <li id="uag-23">
          <strong>Assignment.</strong>
          This Agreement and the rights and obligations created hereunder shall be binding upon and inure solely to the
          benefit of Motto and Member and their respective successors and assigns, and no other person or legal entity
          shall acquire or have any rights under or by virtue of this Agreement. This Agreement may be assigned by Motto
          to a corporate affiliate, subsidiary or successor in interest, in Motto’s sole discretion. This Agreement may
          not be assigned or otherwise transferred by Member without the prior written consent of Motto.
        </li>
        <li id="uag-24">
          <strong>Severability Clause.</strong>
          If any term or condition of this Agreement or application of any such term or condition is held unlawful or
          invalid, the remainder of this Agreement and the application of such term or condition other than to the
          extent it is held unlawful or invalid, will not be held unlawful, invalidated, or affected thereby, and shall
          remain in full force and effect.
        </li>
        <li id="uag-25">
          <strong>No Waiver.</strong>
          A failure by Motto or Member to enforce at any time any term or condition of this Agreement shall not be
          considered a waiver of that party’s right thereafter to enforce that same term or condition or any other term
          or condition of this Agreement.
        </li>
        <li id="uag-26">
          <strong>Headings.</strong>
          The headings contained in this Agreement are for convenience only and shall not affect the construction of any
          provision of this Agreement.
        </li>
        <li id="uag-27">
          <strong>No Joint Venture.</strong>
          Motto and Member agree that this Agreement does not create a joint venture, partnership, employment, or agency
          relationship as a result of this Agreement or Member’s use of the Portal. Motto and Member expressly
          understand and agree that each party is acting as an independent contractor unrelated to the other party or
          its subsidiaries or affiliates.
        </li>
        <li id="uag-28">
          <strong>Third Parties&rsquo; Networks.</strong>
          The Portal may contain hyperlinks to websites operated by parties other than Motto. Motto does not control
          such websites and is not responsible for their content or the availability, security or integrity of any
          information submitted to such websites. Motto’s inclusion of hyperlinks to such websites does not imply any
          endorsement of the material, products or services on such websites or any association with their operators.
          The Portal contains functionalities and services that allow sending, delivering or receiving information
          between Members, Motto and third parties, which may be relayed or carried through Motto, public, third
          parties’ or other networks, systems, servers, websites, applications, or Software as a Service ("SaaS") (e.g.,
          telephone and cellular networks, e-mail servers) ("Third Parties’ Networks"). The Third Parties’ Networks are
          not controlled by Motto in any way and Motto shall not be held responsible for the performance, security,
          integrity, availability, functionality, quality or reliability of any of the Third Parties’ Networks or the
          information sent, delivered, relayed, carried or received through the Third Parties’ Networks. Notwithstanding
          anything herein, Motto does not warrant or guarantee that the information sent, relayed, carried or delivered
          through these Third Parties’ Networks will reach its destination or its correct address or recipient, that the
          details of the recipient or sender are correct or accurate, or that the integrity or confidentiality of the
          information will be maintained in transit.
        </li>
        <li id="uag-29">
          <strong>Additional Terms for Areas of the Portal.</strong>
          Additional terms apply to certain optional features of the Website, namely: a) the Learning Library Inc. Terms
          and Conditions apply to Motto University; (b) The shop.mottomortgage.com Terms of Service and Privacy Policy
          apply to shop.mottomortgage.com; (c) the policies and terms of use of LenderHomePage.com apply to it; and (d)
          the policies and terms of use of United Wholesale Mortgage Design Center apply to it. In the event of, and to
          the extent of conflict between any term of this Agreement and any of the additional terms listed in this
          paragraph, the additional terms will apply.
        </li>
        <li id="uag-30">
          <strong>Force Majeure.</strong>
          Motto shall not be liable for, and shall be excused from, any failure to deliver or perform, or for any delay
          in delivery or performance, due to causes beyond its reasonable control, after exercising its best
          commercially reasonable efforts to remedy any such failure or delay, including without limitation any
          government actions, fire, work stoppages, civil disturbances, interruptions of power or communications to
          Motto or any facilities used by or for Motto, failure of the Internet, hosting, telecommunications, or other
          services to Motto or facilities used by or for Motto, natural disasters, acts of God, or acts of terrorism or
          war.
        </li>
        <li id="uag-31">
          <strong>Notice.</strong>
          Whenever Member is required by the terms of this Agreement to provide notice to Motto or obtain written
          permission from Motto, it shall be sent via e-mail to
          <a href="mailto:privacy@mottomortgage.com" target="_blank">privacy@mottomortgage.com</a>
          .
        </li>
      </ol>
      <MottoIcon
        :class="$style.backButton"
        name="Arrow"
        icon-color="gray"
        class="cursor-pointer"
        @click.native="$router.go(-1)" />
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.userAgreement {
  @media (max-width: $lg-breakpoint) {
    height: auto;
  }

  width: 90%;
  height: 80vh;
  margin: 0 auto;
  overflow-y: scroll;
}

.backButtonTop {
  @media (max-width: $lg-breakpoint) {
    position: absolute;
    top: 15px;
    left: 10px;
    display: block;

    > svg {
      width: 35px;
      height: 35px;
    }
  }

  display: none;
}

.backButton {
  @media (max-width: $lg-breakpoint) {
    display: block;
    margin-top: 20px;

    > svg {
      width: 35px;
      height: 35px;
    }
  }

  display: none;
}
</style>
